import { render, staticRenderFns } from "./DancerAppBar.vue?vue&type=template&id=37ab555c&scoped=true"
import script from "./DancerAppBar.vue?vue&type=script&lang=js"
export * from "./DancerAppBar.vue?vue&type=script&lang=js"
import style0 from "./DancerAppBar.vue?vue&type=style&index=0&id=37ab555c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab555c",
  null
  
)

export default component.exports